import LoadingSpinner from "app/components/LoadingSpinner/LoadingSpinner";
import { FreshworksHelper } from "app/helpers/freshworksHelper";
import isPublicView from "app/utils/publicViewUtils";
import { useEffect, useState } from "react";
import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import { Redirect, Route, Switch, useHistory } from "react-router-dom";
import * as fundingAPI from "../../api/fundingApi";
import { getRoutePathForView, ROUTES } from "../../helpers/routerPathHelper";
import { SessionHelper } from "../../helpers/sessionHelper";
import { AsianStatementTabTypes as TabTypes } from "../../utils/const";
import ManageFunding from "./ManageFunding";
import "./ManageFundingScreenDesktop.scss";
import "./ManageFundingScreenMobile.scss";
import BankWireFundingScreen from "./screens/BankWireFundingScreen/BankWireFundingScreen";
import CryptoFundingScreen from "./screens/CryptoFundingScreen/CryptoFundingScreen";
import NetellerFundingScreen from "./screens/NetellerFundingScreen/NetellerFundingScreen";
import ApplePayFundingScreen from "./screens/NuveiFundingScreens/ApplePayFundingScreen/ApplePayFundingScreen";
import CreditCardFundingScreen from "./screens/NuveiFundingScreens/CreditCardFundingScreen/CreditCardFundingScreen";
import GoogleFundingFundingScreen from "./screens/NuveiFundingScreens/GoogleFundingFundingScreen/GoogleFundingFundingScreen";
import InteracFundingScreen from "./screens/NuveiFundingScreens/InteracFundingScreen/InteracFundingScreen";
import SkrillFundingScreen from "./screens/SkrillFundingScreen/SkrillFundingScreen";

type Gateway = {
  description: string;
  gatewayId: number;
  iconUrl: string;
  id: number;
  name: string;
  type: string;
  depositDetails?: {};
  withdrawDetails?: {};
  updateGateways: Function;
};

function ManageFundingScreen(props: any) {
  const { user, loadUser, setDefaultStatementTab, updateGateways } = props;
  const history = useHistory();
  const [gateways, setGateways] = useState<Gateway[]>([]);
  const [loadingGateways, setLoadingGateways] = useState(true);

  const getFetchGlobalGateways = async () => {
    fundingAPI.fetchGlobalGateways().then(resp => {
      setGateways(resp.gateways);
      setLoadingGateways(false);
      updateGateways(resp.gateways);
      return resp;
    });
  };

  useEffect(() => {
    loadUser();
    getFetchGlobalGateways();
    FreshworksHelper.showWidget();
    return () => {
      if (!isPublicView) {
        FreshworksHelper.hideWidget();
      }
    };
  }, []);

  const onClickFundingHistory = () => {
    let url = "";

    if (SessionHelper.isAsianRouteAndSessionView()) {
      url = ROUTES.asianStatement;
    } else {
      url = ROUTES.statementReports;
      setDefaultStatementTab(TabTypes.FUNDING);
    }

    history.push(url);
  };

  if (!user["userId"]) return <LoadingSpinner />;

  const path = getRoutePathForView();

  return (
    <div
      className={`manage-funding ${
        SessionHelper.isAsianSessionView() ? "manage-funding-asian" : ""
      }`}
    >
      <Switch>
        <Route
          exact
          path={path}
          render={() => (
            <ManageFunding
              gateways={gateways}
              user={user}
              onClickFundingHistory={() => onClickFundingHistory()}
              loadingGateways={loadingGateways}
            />
          )}
        />
        <Route
          path={`${path}aquapay/`}
          render={() => <CryptoFundingScreen user={user} />}
        />
        <Route
          path={`${path}skrill/`}
          render={() => <SkrillFundingScreen user={user} />}
        />
        <Route
          path={`${path}neteller/`}
          render={() => <NetellerFundingScreen user={user} />}
        />
        <Route
          path={`${path}bankwire/`}
          render={() => <BankWireFundingScreen user={user} />}
        />
        <Route
          path={`${path}nuvei/`}
          render={() => <CreditCardFundingScreen />}
        />
        <Route
          path={`${path}interac/`}
          render={() => <InteracFundingScreen />}
        />
        <Route
          path={`${path}apple_pay/`}
          render={() => <ApplePayFundingScreen />}
        />
        <Route
          path={`${path}google_pay/`}
          render={() => <GoogleFundingFundingScreen />}
        />
        <Redirect to={path} />
      </Switch>
    </div>
  );
}

const mapStateToProps = state => ({
  user: state.userModel.user,
});

const mapDispatchToProps = (dispatch: any) => ({
  loadUser: () => {
    dispatch.userModel.loadUser();
  },
  setDefaultStatementTab: tabType => {
    dispatch.statementListModel.setDefaultTab(tabType);
  },
  updateGateways: gateways => {
    dispatch.cashierModel.updateGateways(gateways);
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(ManageFundingScreen));
